import React, { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const TargetForm = () => {
  const [formData, setFormData] = useState({
    deptId: "",
    fromDate: "",
    toDate: "",
    setPatentTarget: "",
    setPubTarget: "",
  });

  const [tid, setTid] = useState('');
  const [departments, setDepartments] = useState([]);
  const [error, setError] = useState("");
  const [editMode, setEditMode] = useState(false);

  // Fetch departments from the backend
  const getDepartments = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/departments`);
      setDepartments(response.data);
    } catch (error) {
      console.error("Error fetching departments:", error);
      setError("Failed to load departments.");
    }
  };

  useEffect(() => {
    getDepartments();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => {
      let updatedData = { ...prevData, [name]: value };

      if (name === "fromDate") {
        const fromYear = parseInt(value);
        updatedData.toDate = value ? `${fromYear + 1}-06-30` : "";
      }

      return updatedData;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/targets/${formData.deptId}/${formData.fromDate}/${formData.toDate}`
      );
  
      if (response.data) {
        toast.info("Target already exists.", { autoClose: 4000 });
  
        setTid(response.data.targetId);
        setFormData({
          ...formData,
          setPatentTarget: response.data.setPatentTarget || "",
          setPubTarget: response.data.setPubTarget || "",
        });
        setEditMode(true);
        setError(""); 
        return;
      }
    } catch (error) {
      console.log("No existing target found, proceeding to create a new one.");
    }
  
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/targets`, {
        department: { deptId: formData.deptId },
        fromYear: formData.fromDate,
        toYear: formData.toDate,
        setPatentTarget: parseInt(formData.setPatentTarget, 10),
        setPubTarget: parseInt(formData.setPubTarget, 10),
      });
  
      toast.success("Target saved successfully!", { autoClose: 3000 });
      resetForm();
    } catch (error) {
      console.error("Error saving target", error);
      toast.error("Failed to save target.");
    }
  };
  
  

  const handleEditOrUpdate = async (e) => {
    e.preventDefault();
    if (editMode) {
      // Update Target
      try {
        const payload = {
          setPatentTarget: parseInt(formData.setPatentTarget || "0", 10),
          setPubTarget: parseInt(formData.setPubTarget || "0", 10),
        };

        // Send PUT request to the correct endpoint
        await axios.put(
          `${process.env.REACT_APP_API_BASE_URL}/api/targets/updateTargets/${formData.deptId}/${formData.fromDate}/${formData.toDate}`,
          payload
        );

        alert("Target updated successfully!");
        resetForm();
        setEditMode(false);
      } catch (error) {
        console.error("Error updating target:", error);
        alert("Failed to update target");
      }
    } else {
      // Fetch Target Data
      fetchTargetData();
    }
  };

  const fetchTargetData = async () => {
    if (!formData.deptId || !formData.fromDate || !formData.toDate) {
      setError("Please select Department, From Date, and To Date.");
      return;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/targets/${formData.deptId}/${formData.fromDate}/${formData.toDate}`
      );

      if (response.data) {
        setTid(response.data.targetId);
        setFormData({
          ...formData,
          setPatentTarget: response.data.setPatentTarget || "",
          setPubTarget: response.data.setPubTarget || "",
        });
        setEditMode(true);
        setError("");
      } else {
        setError("Target data not found for the selected criteria.");
        resetForm();
      }
    } catch (error) {
      console.error("Error fetching target:", error);
      setError("Target not found.");
      resetForm();
    }
  };

  const resetForm = () => {
    setFormData({
      deptId: "",
      fromDate: "",
      toDate: "",
      setPatentTarget: "",
      setPubTarget: "",
    });
  };

  return (
    <div className="container mt-5">
    <ToastContainer position="top-right" autoClose={3000} />
      <h2 className="mb-4 text-center"><bold>SET TARGET</bold></h2>
      <form onSubmit={handleSubmit} className="border p-4 rounded shadow mx-auto" style={{ maxWidth: "500px" }}>
     

        {/* Department Dropdown */}
        <div className="mb-3">
          <label className="form-label">Department</label>
          <select
            name="deptId"
            value={formData.deptId}
            onChange={handleChange}
            className="form-control form-control-sm"
            required
          >
            <option value="">Select Department</option>
            {departments.map((dept) => (
              <option key={dept.deptId} value={dept.deptId}>
                {dept.deptName}
              </option>
            ))}
          </select>
          {error && <small className="text-danger">{error}</small>}
        </div>

        {/* From Date (Select Year) */}
        <div className="mb-3">
          <label className="form-label">Start of Academic Year</label>
          <select
            name="fromDate"
            value={formData.fromDate}
            onChange={handleChange}
            className="form-control form-control-sm"
            required
          >
            <option value="">Select Year</option>
            {[...Array(30)].map((_, index) => {
              const year = new Date().getFullYear() - index;
              return (
                <option key={year} value={`${year}-07-01`}>
                  {year}
                </option>
              );
            })}
          </select>
        </div>

        {/* To Date (Auto-filled Academic Year) */}
        <div className="mb-3">
          <label className="form-label">End of Academic Year</label>
          <input
            type="text"
            name="toDate"
            value={formData.toDate}
            className="form-control form-control-sm"
            disabled
          />
        </div>

        {/* Set Patent Target */}
        <div className="mb-3">
          <label className="form-label">Set Patent Target</label>
          <input
            type="number"
            name="setPatentTarget"
            value={formData.setPatentTarget}
            onChange={handleChange}
            className="form-control form-control-sm"
            required
          />
        </div>

        {/* Set Publication Target */}
        <div className="mb-3">
          <label className="form-label">Set Publication Target</label>
          <input
            type="number"
            name="setPubTarget"
            value={formData.setPubTarget}
            onChange={handleChange}
            className="form-control form-control-sm"
            required
          />
        </div>

        {/* Submit and Edit/Update Button */}
        <div className="d-flex justify-content-between mt-3">
          {/* Submit (Set) button - Hide in Edit Mode */}
{!editMode && (
  <button type="submit" className="btn btn-primary btn-sm" style={{ backgroundColor: 'navy' }}>
    Set
  </button>
)}

{editMode && (
  <div className="text-center h6 bg-secondary p-1 pt-2 pb-2 border rounded text-light" role="alert">
    Target already exists for this department and year. So Targets Auto-fetched for update.
  </div>
)}

{/* Edit/Update Button */}
<button
  type="button"
  onClick={handleEditOrUpdate}
  className="btn btn-primary btn-sm"
  style={{ backgroundColor: 'navy' }}
>
  {editMode ? 'Update' : 'Edit'}
</button>

        </div>
      </form>
    </div>
  );
};

export default TargetForm;